import React from "react";
import './Loading.css';

const Loading = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 block-ui-overlay block-ui-container">
        <div className="block-ui-message-container">
            <div className="block-ui-message">Loading...</div>
        </div>
    </div>
  );
};
 
export default Loading;